import { Chart } from "react-chartjs-2";
import { depthToGroundWaterScale, timeScale } from "../../../types/chart";
import { WellLevelRecord } from "../../../types/scada/wellLevel";
import { wellLevelsSitesReference } from "../../../types/wellLevelsData";
import { useSitesColors } from "../../SiteColorsProvider/SiteColorsProvider";

export function ScadaWellLevelsGraph({ wellLevelData, sites }: { wellLevelData: WellLevelRecord[]; sites: string[] }) {
  const siteColors = useSitesColors(sites, "wellLevels");
  const data = {
    datasets: [
      ...sites.map((id) =>
        toLineDataset(
          wellLevelData.filter((record) => record.wellName.toLowerCase() === id),
          id as keyof typeof wellLevelsSitesReference,
          siteColors[id],
        ),
      ),
    ],
  };
  return <Chart type="bar" options={options()} data={data} />;
}

function toLineDataset(records: WellLevelRecord[], id: keyof typeof wellLevelsSitesReference, color: string) {
  return {
    type: "line" as const,
    label: wellLevelsSitesReference[id].label,
    data: records
      .map((record) => ({
        pointStyle: "circle",
        x: record.date.toISOString(),
        y: record.waterLevelFT,
        backgroundColor: record.pumpStatus === "Running" ? color : "transparent",
      }))
      .sort((a, b) => new Date(a.x).getTime() - new Date(b.x).getTime()),
    backgroundColor: (context: any) => context.raw?.backgroundColor || color,
    borderColor: color,
    yAxisID: "depthToGroundWater",
    pointRadius: 4,
  };
}

export const options = () => ({
  responsive: true,
  scales: {
    x: timeScale,
    depthToGroundWater: depthToGroundWaterScale,
  },
  spanGaps: true,
  plugins: {
    title: {
      display: true,
      text: "Well SCADA Levels and Pump Status (⭕ Empty circles: Pump off)",
    },
  },
});
